import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { ArrowRight, Package } from 'lucide-react';

const COPY = {
  fr: {
    title: ['Gérer son fret', 'avec méthode,', 'jusqu\'à la livraison'],
    desc: "Enregistrement des colis, départs, dédouanement, livraison et facturation dans un "
      + 'seul outil. Aérien et maritime, plusieurs pays, une seule source de vérité.',
    primary: 'Demander une démo',
    secondary: 'Suivre un colis',
    capabilities: ['Aérien et maritime', 'Suivi à chaque étape', 'WhatsApp et e-mail', 'Multi-pays'],
  },
  en: {
    title: ['Run your freight', 'with method,', 'through to delivery'],
    desc: 'Package registration, departures, customs, delivery and invoicing in a single tool. '
      + 'Air and sea, several countries, one source of truth.',
    primary: 'Request a demo',
    secondary: 'Track a package',
    capabilities: ['Air and sea', 'Tracked at every step', 'WhatsApp and email', 'Multi-country'],
  },
};

const Hero = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const copy = COPY[language === 'en' ? 'en' : 'fr'];

  return (
    <section className="landing-hero">
      <div className="landing-hero-inner">
        <h1 className="landing-hero-title">
          {copy.title.map((line, i) => <span key={i}>{line}</span>)}
        </h1>
        <p className="landing-hero-desc">{copy.desc}</p>
        <div className="landing-hero-cta">
          <button onClick={() => navigate('/contact')} className="btn-primary">
            {copy.primary}
            <ArrowRight size={16} />
          </button>
          <button onClick={() => navigate('/track')} className="btn-secondary">
            <Package size={16} />
            {copy.secondary}
          </button>
        </div>
        <ul className="landing-hero-capabilities">
          {copy.capabilities.map((c) => <li key={c}>{c}</li>)}
        </ul>
      </div>
    </section>
  );
};

export default Hero;
